let deferredPrompt = null;

function isInstalled() {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isIOSStandalone = window.navigator.standalone === true;
  return isStandalone || isIOSStandalone;
}

function bannerEl() {
  return document.getElementById('pwa-install-banner');
}

function showInstallBanner() {
  if (bannerEl()) return;

  const el = document.createElement('div');
  el.id = 'pwa-install-banner';
  el.style.position = 'fixed';
  el.style.left = '16px';
  el.style.right = '16px';
  el.style.bottom = '16px';
  el.style.zIndex = '99999';
  el.style.padding = '14px 14px';
  el.style.borderRadius = '12px';
  el.style.background = 'white';
  el.style.boxShadow = '0 10px 30px rgba(0,0,0,.18)';
  el.style.fontFamily = 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif';
  el.innerHTML = `
    <div style="display:flex; gap:12px; align-items:flex-start;">
      <div style="flex:1;">
        <div style="font-weight:700; font-size:14px; margin-bottom:4px;">App installieren</div>
        <div style="font-size:13px; line-height:1.3; opacity:.8;">Schneller Zugriff auf Dein Friseur direkt vom Homescreen.</div>
        <div style="margin-top:10px; display:flex; gap:10px;">
          <button id="pwa-install-yes" style="padding:10px 12px; border-radius:10px; border:0; cursor:pointer; font-weight:700;">Installieren</button>
          <button id="pwa-install-no" style="padding:10px 12px; border-radius:10px; border:1px solid rgba(0,0,0,.15); background:transparent; cursor:pointer;">Später</button>
        </div>
      </div>
      <button id="pwa-install-close" aria-label="Close" style="border:0; background:transparent; cursor:pointer; font-size:18px; line-height:1; padding:2px 6px;">×</button>
    </div>
  `;

  document.body.appendChild(el);

  document.getElementById('pwa-install-yes').addEventListener('click', async () => {
    await triggerInstall();
  });

  document.getElementById('pwa-install-no').addEventListener('click', () => {
    hideInstallBanner();
    sessionStorage.setItem('pwaBannerDismissed', '1');
  });

  document.getElementById('pwa-install-close').addEventListener('click', () => {
    hideInstallBanner();
    sessionStorage.setItem('pwaBannerDismissed', '1');
  });
}

function hideInstallBanner() {
  const el = bannerEl();
  if (el) el.remove();
}

async function triggerInstall() {
  if (!deferredPrompt) return;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  if (outcome === 'accepted') hideInstallBanner();
}

function maybeShowInstallBanner() {
  if (isInstalled()) return;
  if (!deferredPrompt) return;
  if (sessionStorage.getItem('pwaBannerDismissed') === '1') return;
  showInstallBanner();
}

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  maybeShowInstallBanner();
});

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  hideInstallBanner();
});

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) maybeShowInstallBanner();
});
